import { render } from "./TablModuLOV.vue?vue&type=template&id=28af6580"
import script from "./TablModuLOV.vue?vue&type=script&lang=js"
export * from "./TablModuLOV.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__